import React from 'react';
import { connect } from 'react-redux';
import { showLoadingIndicator } from './redux/actions';
import { Box } from '@mui/material';

import Newsletter from './scenes/Home/Newsletter';
import Featured from './scenes/Home/Featured/Featured.js';
import HeroSection from './scenes/Home/HeroSection/HeroSection.jsx';
import QuickServices from './scenes/Home/QuickServices.js';
import FeaturedDrugs from './scenes/Home/FeaturedDrugs.js';
import FeaturedEquipments from './scenes/Home/FeaturedEquipments.js';
import CTASection from './scenes/Home/CTASection.js';
import FeaturedServices from './scenes/Home/FeaturedServices.js';

const mapStateToProps = (state) => ({
  showLoading: state.showLoading
});

const mapDispatchToProps = {
  showLoadingIndicator
};

function Home ({ showLoading, showLoadingIndicator }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <HeroSection />
      <FeaturedDrugs />
      <QuickServices />
      <FeaturedEquipments />
      <CTASection />
      <FeaturedServices />
    </Box>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
